import MuiChip from "@mui/material/Chip";
import * as React from "react";

import { ComponentProps } from "./chip.type";

const Chip = ({ color, label, bgColor, onClick }: ComponentProps) => {
  return (
    <MuiChip
      label={label}
      sx={{ color: color, backgroundColor: bgColor }}
      onClick={onClick}
    />
  );
};

export default Chip;
